import { servicePresignaArchivo } from '../api/api-presigna-archivo';

export const esArchivoGrande = (file, limiteLivianoBytes) => file.size > limiteLivianoBytes;

export const subirArchivoGrandeS3 = async (file) => {
    const query = Buffer.from(JSON.stringify({ filename: file.name })).toString('base64');
    const { url, fields, s3Bucket, s3Key } = await servicePresignaArchivo(query);

    const form = new FormData();
    Object.keys(fields).forEach(key => form.append(key, fields[key]));
    form.append('file', file);

    const resp = await fetch(url, { method: 'POST', body: form });
    if (resp.status !== 204) throw new Error('Error al subir el archivo a S3.');

    return { s3Bucket, s3Key };
};
